export default "__VITE_ASSET__CSK_Ik15__"